import { FC } from 'react';

import { Tag, TagVariant } from '../../../components/tag/index';
import { useLocale } from '../../../hooks/index';
import {
  SignatureStatus,
  signatureStatusTranslationKey,
} from '../../documents/signatures/enums/signature-status.const';

export type EventSignatureStatusCellProps = {
  signatureSignedCount?: number;
  signatureStatus?: SignatureStatus | string;
  signatureTotalCount?: number;
};

const getStatusVariant = (status: SignatureStatus | string | undefined): TagVariant => {
  switch (status) {
    case SignatureStatus.DOCUMENT_EXPIRED:
      return TagVariant.RED;
    case SignatureStatus.FULLY_SIGNED:
      return TagVariant.GREEN;
    case SignatureStatus.PARTIALLY_SIGNED:
      return TagVariant.BLUE;
    case SignatureStatus.SIGNATURE_PENDING:
      return TagVariant.YELLOW;
    case SignatureStatus.VOIDED:
      return TagVariant.GRAY;
    default:
      return TagVariant.RED;
  }
};

export const EventSignatureStatusCell: FC<EventSignatureStatusCellProps> = ({
  signatureStatus,
  signatureSignedCount,
  signatureTotalCount,
}) => {
  const { messagesLocale } = useLocale();

  if (!signatureStatus) return <span className="text-sm text-gray-400">-</span>;

  const baseStatusLabel =
    signatureStatus in signatureStatusTranslationKey
      ? messagesLocale[signatureStatusTranslationKey[signatureStatus as SignatureStatus]]
      : String(signatureStatus);

  const statusLabel =
    signatureStatus === SignatureStatus.PARTIALLY_SIGNED &&
    signatureTotalCount != null &&
    signatureTotalCount > 0
      ? `${baseStatusLabel} ${signatureSignedCount ?? 0}/${signatureTotalCount}`
      : baseStatusLabel;

  return <Tag title={statusLabel} variant={getStatusVariant(signatureStatus)} />;
};
